import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('jobManagementStore')
@observer
class JobManagement extends Component {
  render() {
    const { jobManagementStore,location } = this.props
    const { isFetching } = jobManagementStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location} />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default JobManagement;
